import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AIDraftsChart() {
	const query = api.analytics.aiDraftsChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Drafts"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
